import { create } from 'zustand';

import { CardTypeVariant } from '@/components/views/Admin/components/Navbar/CardOfNotification';

export interface Message {
  SecUserNotTitle: string;
  SecUserNotURL: string;
  SecUserId: number;
  SecUserNotId: number;
  SecUserNotType: CardTypeVariant;
  SecUserNotMsg: string;
}

export interface HelpNotificationModalProps {
  messages: Message[];
}

interface WebSocketStoreState {
  isConnected: boolean;
  errorMessage: string | null;
  messages: Message[];
  messageNotification: string | null;
}

interface WebSocketStoreActions {
  setIsConnected: (isConnected: boolean) => void;
  setErrorMessage: (errorMessage: string | null) => void;
  setMessages: (messages: Message[]) => void;
  setMessageNotification: (messageNotification: string | null) => void;
}

type WebSocketStore = WebSocketStoreState & WebSocketStoreActions;

export const useWebSocketNotificationsStore = create<WebSocketStore>((set) => ({
  isConnected: false,
  errorMessage: null,
  messages: [] as Message[],

  messageNotification: null,
  setIsConnected: (isConnected: boolean) => set({ isConnected }),
  setErrorMessage: (errorMessage: string | null) => set({ errorMessage }),
  setMessages: (messages: Message[]) => set({ messages }),
  setMessageNotification: (messageNotification: string | null) => set({ messageNotification }),
}));
